import {
  ClassificationTier,
  getEngagementBadgeProps as getEngagementBadgePropsForTiers,
  getReachBadgeProps,
} from "../classification";

const ENGAGEMENT_TIERS: ClassificationTier[] = [
  {
    maxFollowers: 5000,
    tiers: [0.05275, 0.15825, 0.26375, 0.422, 0.633, Infinity],
  },
  {
    maxFollowers: 20000,
    tiers: [0.0046, 0.138, 0.23, 0.368, 0.552, Infinity],
  },
  {
    maxFollowers: 100000,
    tiers: [0.00391, 0.1173, 0.1955, 0.3128, 0.4692, Infinity],
  },
  {
    maxFollowers: 500000,
    tiers: [0.00388, 0.1164, 0.1941, 0.3106, 0.4659, Infinity],
  },
  {
    maxFollowers: 1000000,
    tiers: [0.0425, 0.12765, 0.21275, 0.3404, 0.5106, Infinity],
  },
  {
    maxFollowers: Infinity,
    tiers: [0.0432, 0.1296, 0.216, 0.3456, 0.5184, Infinity],
  },
];

export const getEngagementBadgeProps = (engagement: number, followers: number) =>
  getEngagementBadgePropsForTiers(engagement, followers, ENGAGEMENT_TIERS);

export { getReachBadgeProps };
